import { render, staticRenderFns } from "./DiagnosisPlanDownload.vue?vue&type=template&id=33b99cc8&scoped=true&"
import script from "./DiagnosisPlanDownload.vue?vue&type=script&lang=js&"
export * from "./DiagnosisPlanDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b99cc8",
  null
  
)

export default component.exports